



























































































































































import { Component, Prop, Vue } from 'vue-property-decorator'
import {mapGetters} from 'vuex'
import BuilderDeviceHighlight from '@/components/builder/BuilderDeviceHighlight.vue'


interface Post {
  id: number
  file: null | string | File
}

interface ProcessedPost {
  id: number
  file: null | string
  locked: boolean
}

@Component({
  components: {
    BuilderDeviceHighlight,
  },
  computed: {
    ...mapGetters('builder', { appType: 'getAppType' }),
  },
})
export default class BuilderDeviceProfilePostsStub extends Vue {
  @Prop({ required: true, type: String }) color!: string

  @Prop({ default: true, type: Boolean }) blur!: boolean

  @Prop({ default: false, type: Boolean }) highlight!: boolean

  @Prop({ default: false, type: Boolean }) halfVisible!: boolean

  @Prop({ default: null }) posts!: null | Post[]

  appType!: string

  get productsExample(): any[] { 
    return [
    {
      id: 1,
      price: 199,
      oldPrice: 250,
      discount: 20,
      comments: 2662,
      image: require('@/assets/images/crm/example/product1.jpg'),
      description: this.$t('exampleProduct1.description')
    },
    {
      id: 2,
      price: 95,
      oldPrice: 130,
      discount: 30,
      comments: 1327,
      image: require('@/assets/images/crm/example/product2.jpg'),
      description: this.$t('exampleProduct2.description')
    },
  ]
  }
  get postExample(): any[] {
    if(this.$route.name === 'profile.create_post' || this.$route.name === 'create' || this.$route.name === 'profile-created') {
      return []
    }
    return [
    {
      id: 1,
      image: require('@/assets/images/crm/example/post1.jpg'),
    },
    {
      id: 2,
      image: require('@/assets/images/crm/example/post2.jpg'),
    },
    {
      id: 3,
      image: require('@/assets/images/crm/example/post3.jpg'),
    },
    
  ]
  }
  get blockHeight(): string {
    
    if(window.innerWidth < 460) {
      return '356px'
    }
    if(this.halfVisible) {
      return '150px'
    }
    if(this.$route.name === 'profile.followers') {
      return '250px'
    }
    if(this.appType === 'TYPE_BLOGER' || this.$route.name === 'profile.create_post') {
      return '210px'
    }
    return '312px'
    
  }
  get currencyByLanguage():string {
    if(this.$i18n.locale == 'ru') {
      return '₽'
    }
    return '$'
  }
  get processedPosts(): ProcessedPost[] {
    if (!this.posts) {
      return Array.from(new Array(6)).map((_, i) => ({
        id: -i - 1,
        file: null,
        locked: i === 2,
      }))
    }

    return Array.from(new Array(6)).map((_, i) => {
      const item = this.posts && this.posts[i]

      if (!item) {
        return { id: -i - 1, file: null, locked: i === 2 }
      }

      return {
        id: item.id,
        file: item.file instanceof File ? URL.createObjectURL(item.file) : item.file,
        locked: false,
        isVideo: this.isFileTypeVideo(item)
      }
    })
  }
  get isStepPosts(): boolean {
    if(this.$route.name === 'profile.create_post') {
      return true  
    }
    return false
  }
  get grayscale():string {
    return this.blur ? 'filter grayscale' : ''
  }
  isFileTypeVideo(file) {
    if('type' in file && file.type === 2) {
      return true
    }
    if('mime' in file && file.mime?.split('/')[0] === 'video') {
      return true
    }
    return false
  }
}
